import { generateCreateActionCreator, generateReadActionCreator } from '../crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';
import routes from 'actions/routes';

export default {
    addFee: generateCreateActionCreator(routes.API_PRODUCT_FEES, ACTION_NAMES.PRODUCT_FEES),
    readFee: generateReadActionCreator(routes.API_PRODUCT_FEES, ACTION_NAMES.PRODUCT_FEES)
}
